import { VALUE_PROPERTY_TYPES, createValueProperty } from '../../../../../utils/valuePresentation';

export function ValueSchemaEditor({ valueSchema, onChange }) {
    const schema = Array.isArray(valueSchema) ? valueSchema : [];

    const updateAt = (index, patch) => {
        onChange(schema.map((item, i) => i === index ? { ...item, ...patch } : item));
    };

    const move = (index, direction) => {
        const next = [...schema];
        const target = index + direction;
        if (target < 0 || target >= next.length) return;
        const [item] = next.splice(index, 1);
        next.splice(target, 0, item);
        onChange(next.map((entry, i) => ({ ...entry, order: i })));
    };

    const onDropType = (event) => {
        event.preventDefault();
        const type = event.dataTransfer.getData('text/property-type');
        if (!type) return;
        onChange([...schema, createValueProperty(type, schema)]);
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
                <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Value template</label>
            </div>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.7rem', color: 'var(--text-secondary)' }}>
                Add fields once for this feature. Every value uses this template; select a value to fill it in. Bullet and numbered lists can have any number of items on each value.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginBottom: '0.65rem' }}>
                {VALUE_PROPERTY_TYPES.map(type => (
                    <button
                        key={type.type}
                        type="button"
                        draggable
                        onDragStart={(event) => event.dataTransfer.setData('text/property-type', type.type)}
                        onClick={() => onChange([...schema, createValueProperty(type.type, schema)])}
                        style={{
                            border: '1px dashed var(--border)',
                            background: 'var(--bg-secondary)',
                            borderRadius: '999px',
                            padding: '0.2rem 0.55rem',
                            fontSize: '0.65rem',
                            cursor: 'grab'
                        }}
                    >
                        <i className={`fa-solid ${type.icon}`} style={{ marginRight: '0.3rem' }}></i>
                        {type.label}
                    </button>
                ))}
            </div>
            <div
                onDragOver={(event) => event.preventDefault()}
                onDrop={onDropType}
                style={{
                    minHeight: '72px',
                    border: '1px dashed var(--border)',
                    borderRadius: '8px',
                    padding: '0.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.4rem'
                }}
            >
                {schema.length === 0 && (
                    <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>Drop template fields here</span>
                )}
                {schema.map((item, index) => (
                    <div key={`${item.key}-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: '6px', padding: '0.45rem' }}>
                        <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }}>
                            <strong style={{ fontSize: '0.7rem', flex: 1 }}>{VALUE_PROPERTY_TYPES.find(type => type.type === item.type)?.label || item.type}</strong>
                            <button type="button" className="btn-secondary" style={{ padding: '0.15rem 0.35rem' }} onClick={() => move(index, -1)} disabled={index === 0}>
                                <i className="fa-solid fa-chevron-up" style={{ fontSize: '0.65rem' }}></i>
                            </button>
                            <button type="button" className="btn-secondary" style={{ padding: '0.15rem 0.35rem' }} onClick={() => move(index, 1)} disabled={index === schema.length - 1}>
                                <i className="fa-solid fa-chevron-down" style={{ fontSize: '0.65rem' }}></i>
                            </button>
                            <button type="button" className="btn-secondary" style={{ padding: '0.15rem 0.35rem', color: 'var(--error)' }} onClick={() => onChange(schema.filter((_, i) => i !== index))}>
                                <i className="fa-solid fa-trash-can" style={{ fontSize: '0.65rem' }}></i>
                            </button>
                        </div>
                        <input
                            className="input-field"
                            value={item.label}
                            onChange={(e) => updateAt(index, { label: e.target.value })}
                            placeholder="Label"
                            style={{ margin: 0, padding: '0.25rem 0.4rem', fontSize: '0.7rem' }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
